import { fromJS } from 'immutable';

import {
  SHOW_EXISTING_DELIVERABLE_SUCCESS,
  CLEAR_EXISTING_DELIVERABLE,
} from './constants';

const initialState = fromJS({
  isUpdatingDeliverable: false,
  deliverable: {},
});

function deliverableAssignReducer(state = initialState, action) {
  switch (action.type) {
  case SHOW_EXISTING_DELIVERABLE_SUCCESS:
    return state
      .set('deliverable', action.deliverable)
      .set('isUpdatingDeliverable', true);
  case CLEAR_EXISTING_DELIVERABLE:
    return initialState;
  default:
    return state;
  }
}

export default deliverableAssignReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/deliverable-assign-modal/reducer.js
 **/